import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgContentCopy = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5 3.75a.25.25 0 0 0-.25.25v12.5a.75.75 0 0 1-1.5 0V4c0-.966.784-1.75 1.75-1.75h9a.75.75 0 0 1 0 1.5zm3.5 3.5a.25.25 0 0 0-.25.25V20c0 .138.112.25.25.25H19a.25.25 0 0 0 .25-.25V7.5a.25.25 0 0 0-.25-.25zm-1.75.25c0-.966.784-1.75 1.75-1.75H19c.966 0 1.75.784 1.75 1.75V20A1.75 1.75 0 0 1 19 21.75H8.5A1.75 1.75 0 0 1 6.75 20z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgContentCopy;
